import React, {useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {useDispatch, useSelector} from "react-redux";

import {ContainerHeader, SortableTableMat} from "../../module";
import Table from '@mui/material/Table';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {number} from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import {Link, useHistory} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import {TableSortLabel} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";
import ModalAlerterCallback from '../../utils/ModalAlerterCallback';
import {deleteCategory} from "../../../stores/category/thunks";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    actions: {
        display: 'flex !important',
        flexDirection: 'row',
        gap: '0 10px'
    },
    editIcon: {
        color: '#FF8C00',
    },
    deleteIcon: {
        color: 'red',
    },
    viewEx: {
        color: '#0054a7',
    },
    item: {
        padding: '16px 8px',
    },
}));


const headCells = [
    {
        id: 'title',
        numeric: false,
        disablePadding: false,
        label: 'عنوان',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: '',
        sort: true,
    },
];

export default function Categories() {

    const dispatch = useDispatch();
    const history = useHistory();

    function removeProduct(category_id, refreshTable) {
        const callback = () =>
            dispatch(deleteCategory({category_id}, refreshTable));
        ModalAlerterCallback(callback);
        // dispatch(deleteCoursesAdmin({ course_id }));
    }


    const ExerciseHeadMedel = (props) => {
        const classes = useStyles();
        const {headCell, order, orderBy} = props;

        return (
            <TableCell
                key={headCell.id}
                align={headCell.numeric ? 'right' : 'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
            >
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    // onClick={createSortHandler(headCell.id)}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                    ) : null}
                </TableSortLabel>
            </TableCell>
        );
    };

    const ExerciseRowTableModel = (props) => {
        const dispatch = useDispatch();
        const history = useHistory();
        const classes = useStyles();
        const {row, onRemove, refreshTable} = props;
        const [open, setOpen] = React.useState(false);

        function handleRemove(id) {
            onRemove(id, refreshTable);
        }

        function handleShow() {
            // dispatch(setExModalData(row));
            // onRemove(row.id, refreshTable);
        }

        function handleEdit() {
            // dispatch(setExModalData(row));
            history.push(`/exercises/${row.exercise_id}`);
        }

        return (
            <>
                <TableRow hover tabIndex={-1} key={row.id} sx={{'& > *': {borderBottom: 'unset !important'}}}>
                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left" className={classes.actions}>
                        <Link to={`/category/${row.id}`}>
                            <Tooltip title="ویرایش">
                                <IconButton>
                                    <EditIcon/>
                                </IconButton>
                            </Tooltip>
                        </Link>
                        <div onClick={()=>handleRemove(row.id)}>
                            <Tooltip title="حذف">
                                <IconButton>
                                    <DeleteIcon/>
                                </IconButton>
                            </Tooltip>
                        </div>
                        <div onClick={() => setOpen(!open)}>
                            <Tooltip title="نمایش">
                                <IconButton>
                                    {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                                </IconButton>
                            </Tooltip>
                        </div>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className="noPadding" colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{margin: 1, paddingX:5}}>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>عنوان</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.children.map((historyRow) => (
                                            <TableRow key={historyRow.date}>
                                                <TableCell component="th" scope="row">
                                                    {historyRow.name}
                                                </TableCell>
                                                <TableCell className={classes.actions}>
                                                    <Link to={`/category/${historyRow.id}`}>
                                                        <Tooltip title="ویرایش">
                                                            <IconButton>
                                                                <EditIcon/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Link>
                                                    <div onClick={()=>handleRemove(historyRow.id)}>
                                                        <Tooltip title="حذف">
                                                            <IconButton>
                                                                <DeleteIcon/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        );
    };

    function addCategory() {
        history.push('/category');
    }

    return (
        <Grid item xs={11} sm={12} className="d-flex flex-column DivParentCreateProduct">
            <ContainerHeader
                data={{
                    filter: false,
                    addBtn: true,
                }}
                headerTitle="لیست دسته بندی"
                titleBtn="افزودن دسته بندی"
                addBtnAction={addCategory}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />
            <SortableTableMat
                link={'category'}
                RowComponent={ExerciseRowTableModel}
                HeadCompnent={ExerciseHeadMedel}
                headers={headCells}
                version={1}
                keyData={'categories'}
                onRemove={removeProduct}
            />
        </Grid>
    );
}